<template>
  <section class="fixed inset-0 flex items-center justify-center z-[32] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal modal-table"
      class="modal absolute block bg-white dark:bg-dark-800 w-5/6 sm:w-9/12 md:w-5/12 lg:w-6/12 xl:w-6/12 shadow-md rounded-lg dark:shadow-dark-600"
      :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">Pilih Customer</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <SearchBox v-model="search" placeholder="Cari Customer" class-add="w-full" />
        <TableComponent>
          <TableHead>
            <TableRow>
              <TableHeadCell>No</TableHeadCell>
              <TableHeadCell>Action</TableHeadCell>
              <TableHeadCell>Pelanggan</TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow v-if="allCustomers.length == 0">
              <TableCell colspan="6" customClass="text-center italic text-gray-400 dark:text-gray-500" noTextColor>
                Belum ada data
              </TableCell>
            </TableRow>
            <TableRow v-else v-for="(customer, index) in allCustomers" :key="customer.id" :index="index" isBody>
              <TableCell>{{ index + 1 }}</TableCell>
              <TableCell class="text-gray-500 flex">
                <button @click="selectCustomer(customer)" class="bg-success hover:bg-hover-success flex justify-center items-center mx-1 p-2 rounded-md group">
                  <CheckIcon class="h-4 w-4 text-white group-hover:text-light-50" />
                </button>
              </TableCell>
              <TableCell>
                <div class="space-y-1">
                  <p class="font-semibold">{{ customer.fullname }}</p>
                  <p class="text-sm text-gray-600 dark:text-gray-400">
                    <span v-if="customer.phone">{{ customer.phone }} • </span>
                    {{ customer.email }}
                  </p>
                  <p v-if="customer.address" class="text-sm text-gray-600 dark:text-gray-400">
                    {{ customer.address }}
                  </p>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </TableComponent>
        <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white"
            @click="closeModal" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SubmitButton from '../form/SubmitButton.vue';
import { mapGetters } from 'vuex';
import { TableComponent, TableHead, TableBody, TableRow, TableCell, TableHeadCell } from '@/components/table';
import { CheckIcon } from '@heroicons/vue/24/solid';
import SearchBox from '@/views/pages/new-transaction/SearchBox.vue';
import PaginationButtons from '../PaginationButtons.vue';

export default {
  name: "ModalChooseCustomer",
  components: {
    SubmitButton, TableComponent, TableHead, TableBody, TableRow, TableCell, TableHeadCell, CheckIcon, SearchBox, PaginationButtons
  },
  data() {
    return {
      showModal: true,
      search: '',
      currentPage: 1,
      totalPages: 1,
      searchTimeout: null
    }
  },
  computed: {
    ...mapGetters('customers', ['allCustomers']),
  },
  watch: {
    currentPage: {
      handler(newVal) {
        this.fetchCustomers({ page: newVal });
      },
    },
    search: {
      immediate: true,
      handler(newVal) {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        
        this.searchTimeout = setTimeout(() => {
          if (newVal.length > 1) {
            this.fetchCustomers({ fullname: newVal });
          } else {
            this.fetchCustomers();
          }
        }, 1500);
      },
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    async fetchCustomers(params = { page: 1, limit: 25 }) {
      if (!params.page) params.page = this.currentPage;
      if (!params.limit) params.limit = 25;

      try {
        const { pagination } = await this.$store.dispatch('customers/fetchCustomers', params);
        if (pagination) {
          this.totalPages = pagination.totalPages;
        }
      } catch (error) {
        console.log(error);
      }
    },
    selectCustomer(customer) {
      this.$confirm.require({
        group: 'headless',
        header: `Apakah anda yakin memilih pelanggan ${customer.fullname}?`,
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.$emit('selectCustomer', customer);
          this.closeModal();
          this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Pelanggan berhasil dipilih', life: 3000 });
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi memilih pelanggan', life: 3000 });
        }
      });
    }
  },
  created() {
    this.$store.dispatch('customers/fetchCustomers');
  }
}
</script>
